// Skeleton de carga — bloques que aproximan la forma real del contenido en
// vez de un spinner genérico, para que la primera pantalla del Dashboard se
// perciba más rápida y "con calidad" mientras llega la respuesta de la API.
function Bloque({ className = "" }: { className?: string }) {
  return <div className={`animate-pulse rounded-lg bg-borde/60 ${className}`} />;
}

export function EsqueletoDashboard() {
  return (
    <div>
      <div className="mb-6">
        <Bloque className="h-6 w-40" />
        <Bloque className="mt-2 h-4 w-64" />
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Bloque key={i} className="h-24 rounded-xl" />
        ))}
      </div>
      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Bloque className="h-64 rounded-xl" />
        <Bloque className="h-64 rounded-xl" />
      </div>
    </div>
  );
}
